import { api } from './client'

/** The saved slice of the Contacts table a view restores. Opaque to the backend. */
export interface ContactViewConfig {
  q?: string
  owner?: string
  source?: string
  /** A built-in preset (Mine, Unassigned, …) the view sits on. */
  view?: string
  sortColumn?: string
  sortDir?: 'asc' | 'desc'
  columns?: string[]
  pageSize?: number
}

export interface ContactView {
  id: string
  name: string
  shared: boolean
  /** True when the caller owns the view (may edit/delete it). */
  mine: boolean
  config: ContactViewConfig
}

export interface ContactViewInput {
  name: string
  shared: boolean
  config: ContactViewConfig
}

export async function listContactViews(): Promise<ContactView[]> {
  return (await api.get<ContactView[]>('/api/contact-views')).data
}

export async function createContactView(input: ContactViewInput): Promise<ContactView> {
  return (await api.post<ContactView>('/api/contact-views', input)).data
}

export async function updateContactView(id: string, input: ContactViewInput): Promise<ContactView> {
  return (await api.put<ContactView>(`/api/contact-views/${id}`, input)).data
}

export async function deleteContactView(id: string): Promise<void> {
  await api.delete(`/api/contact-views/${id}`)
}
